/**
 * usePageTracking.js — Auto page_view sur changement de route (SPEC-2026-07-03).
 *
 * S'utilise une fois, au niveau de <App/> (dans le contexte <BrowserRouter>).
 * Émet un page_view à chaque navigation client (react-router v6) + init des
 * listeners de flush (pagehide/visibilitychange). Non bloquant.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initAnalytics } from '../services/AnalyticsClient';

export default function usePageTracking() {
  const location = useLocation();
  const last = useRef(null);

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    const key = location.pathname + location.search;
    if (last.current === key) return; // évite les doublons (remount)
    last.current = key;
    // Laisse le titre du document se mettre à jour (Helmet) avant la capture.
    const id = setTimeout(() => trackPageView({ path: location.pathname }), 50);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);
}
